module.exports = __webpack_public_path__ + "static/media/est_0002_t.3c071a18.jpg";